import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 0,
  class: "ml20 color-danger"
}

import { useRoute, useRouter } from 'vue-router'
import { reactive, getCurrentInstance, ref, watch, onMounted, computed } from 'vue'
import { useStore } from '@/store/index'
import { isSensitive } from '@/utils/validator'
import { getSpecialRuleDetailApi, getSpecialRuleCheckDetailApi, saveSpecialRuleApi, getOpenCityListByBrandApi, checkSpecialRuleApi, getBrandRuleInfoApi } from '@/apis/brand'
import { getShopListByBrandApi } from '@/apis/shop'
import { getSecondBrandListNoPageApi } from '@/apis/merchant-admin'
import { getProductListByParamsAPi } from '@/apis/product'
import { DeliveryType } from './enum'
import { UserType } from '@/enums/user'
import { getCurrentDate } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecialRuleEdit',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const route = useRoute()
const store = useStore()
const userBindBrands = ref(store.state.user.userInfo.brandArr || []) // 品牌列表
const userType = store.state.user.userInfo.user_type as number

const t = Number(route.query.t) // 1-编辑 2-查看
const source = route.meta.v // 1-商户端，2-运营端

const formData = ref<any>({
    brand_id:               '',     // 品牌id
    cat_id:                 '',     // 品牌分类id
    is_business_open:       1,      // 营业状态
    is_delivery_enabled:    0,      // 是否发货：0-否，1-是
    start_date:             '',     // 配规开始日期
    end_date:               '',     // 配规结束日期
    delivery_time:          '',     // 上门配送时间段 
    shop_delivery_time:     '',     // 自提时间段
    delivery_type:          '',     // 配送类型
    second_brand_ids:       [],     // 二级品牌id
    city_ids:               [],     // 城市id
    shop_ids:               [],     // 门店id
    product_ids:            [],     // 商品id
    description:            '',     // 配规描述
    ship_amount:            0,      // 运费
})

const id  = Number(route.query.id) // 配规ID
const getSpecialRuleDetail = async () => {
    let result
    if (source == 1) {
        result = await getSpecialRuleDetailApi(id) as any
    } else {
        result = await getSpecialRuleCheckDetailApi(id) as any
    }

    const { code, data, msg } = result
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    if (route.query.is_clone == '1') { // 如果是克隆操作，删除表单中的 ID，清除配规起止日期
        delete data.id
        data.start_date = ''
        data.end_date = ''
    }
    isSameShip.value = !data.ship_amount // 判断是否按照原配送规则收取运费
    // 解析二级品牌
    data.second_brand_ids = data.second_brand_ids ? data.second_brand_ids.split(',').map(item => Number(item)) : []
    // 解析选择的城市
    data.city_ids = data.city_ids ? data.city_ids.split(',').map(item => Number(item)) : []
    // 解析选择的门店
    data.shop_ids = data.shop_ids ? data.shop_ids.split(',').map(item => Number(item)) : []
    // 解析选择的商品
    data.product_ids = data.product_ids ? data.product_ids.split(',').map(item => Number(item)) : []

    formData.value = data
    
    getBrandRule()
    getSecondBrandList()
    getCityList()
    getShopList()
    getProductList()
}
if (id) {
    getSpecialRuleDetail()
}

// 品牌列表与变更监听
const brandList = ref<any>([]) // 品牌列表
const getBrandList = () => {
    proxy.$http.get('/cake_api/get_brand_list').then((res:any) => {
        const {code, data, msg} = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        brandList.value = res.data
    })
}
getBrandList()
const onBrandChange = (val) => {
    formData.value.brand_id = val
    formData.value.delivery_type = ''
}
// 监听品牌变更
watch(() => formData.value.brand_id, (newVal, oldVal) => {
    if (!newVal) return
    if (brandList.value.length) { // 如果品牌变更时，已经有品牌列表了获取品牌对应的 cat_id（主要用于绑定品牌的用户默认选中第一个场景）
        formData.value.cat_id = brandList.value.find(item => item.id === newVal).cat_id // 重新定义当前品牌品类
        if (formData.value.cat_id != 1) {
            getSecondBrandList()
        }
    }
    getBrandRule()
    getCityList()
    getProductList()
})
watch(() => brandList.value, (newVal, oldVal) => {
    if (formData.value.brand_id) { // 如果品牌列表获取成功后已经有品牌选中的品牌了获取品牌对应的 cat_id（主要用于绑定品牌的用户默认选中第一个场景）
        formData.value.cat_id = brandList.value.find(item => item.id === formData.value.brand_id).cat_id // 重新定义当前品牌品类
        if (formData.value.cat_id != 1) {
            getSecondBrandList()
        }
    }
})
onMounted(() => {
    if (!id) { // 如果不是编辑，默认选中当前用户绑定的第一个品牌
        formData.value.brand_id = userBindBrands.value[0]?.id
    }
})

// 是否支持修改运费
const isSupportShipAmount = computed(() => {
    return  Boolean(formData.value.second_brand_ids.length) || // 设置了二级品牌不可修改运费
            Boolean(formData.value.product_ids.length) || // 设置了商品不可修改运费
            formData.value.delivery_type == 1 || // 配送类型仅自提不可修改运费
            ((formData.value.delivery_type == '' || formData.value.delivery_type == 4) && formData.value.is_delivery_enabled == 0) || // 未设置配送类型或快递类型的同时选择了不发货不可修改运费
            formData.value.start_date == getCurrentDate() // 配规开始日期为当天的不可修改运费
})
// 获取不支持修改运费的原因
const getNotSupportShipAmountReason = () => {
    if (formData.value.second_brand_ids.length) {
        return '设置了二级品牌，不可修改运费'
    } else if (formData.value.product_ids.length) {
        return '设置了商品，不可修改运费'
    } else if (formData.value.delivery_type == 1) {
        return '配送类型仅自提，不可修改运费'
    } else if ((formData.value.delivery_type == '' || formData.value.delivery_type == 4) && formData.value.is_delivery_enabled == 0) {
        return '未设置配送类型或快递类型的同时选择了不发货，不可修改运费'
    } else if (formData.value.start_date == getCurrentDate()) {
        return '配规开始日期为当天的，不可修改运费'
    } else {
        return ''
    }
}
// 监听是否支持修改运费
watch(() => isSupportShipAmount.value, (newVal, oldVal) => {
    if (newVal) {
        formData.value.ship_amount = ''
    }
})

// 二级品牌列表与变更监听
const secondBrandList = ref<any>([]) // 二级品牌列表
const getSecondBrandList = async () => {
    const { code, data, msg } = await getSecondBrandListNoPageApi(formData.value.brand_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    secondBrandList.value = data
}
const onSecondBrandChange = () => {
    getProductList()
}

// 城市列表与变更监听
const cityList = ref<any>([]) // 城市列表
const getCityList = async () => {
    const { code, data, msg } = await getOpenCityListByBrandApi({brand_id: formData.value.brand_id}) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    cityList.value = data.data
}
const onCityChange = (val) => {
    if (val.includes(0)) {
        formData.value.city_ids = [0]
    } else {
        formData.value.city_ids = val
    }
    getShopList()
}

// 商品列表
const isProductSelectedAll = ref(false)
const isProductSelectIndeterminate = ref(false)
const productList = ref<any>([])
const getProductList = async () => {
    const { brand_id, second_brand_ids } = formData.value
    const { code, data, msg } = await getProductListByParamsAPi({
        brand_id,
        second_brand_ids: second_brand_ids.join(',')
    }) as any
    
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    productList.value = data
}
const onProductSelectAll = (val) => {
    isProductSelectedAll.value = val
    isProductSelectIndeterminate.value = false
    if (val) {
        formData.value.product_ids = productList.value.map(item => item.id)
    } else {
        formData.value.product_ids = []
    }
}
const onProductChange = (val) => {
    isProductSelectedAll.value = false
    isProductSelectIndeterminate.value = false
    if (val.length === productList.value.length) {
        isProductSelectedAll.value = true
    } else if (val.length > 0) {
        isProductSelectIndeterminate.value = true
    }
}

// 是否发货监听
const onCanDeliveryChange = (val) => {
    // if (formData.value.is_delivery_enabled == 0) {
    //     formData.value.ship_amount = ''
    // }
}

// 获取品牌配规：判断是否为快递类商品
const brandCanDeliveryType = ref<any>('') // 品牌支持的配送类型，
const getBrandRule = async () => {
    const { code, data, msg } = await getBrandRuleInfoApi(formData.value.brand_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    brandCanDeliveryType.value = data.id
    // formData.value.delivery_type = ''
}
const onBusinessOpenChange = (val) => {
    if (val == 0) {
        getShopList()
        // formData.value.ship_amount = ''
        if (formData.value.city_ids == 0) { formData.value.city_ids = [] }
    } else {
        formData.value.shop_ids = []
    }
}

// 配送类型改变时，验证配送时间段或自提时间段是否为空
const onDeliveryTypeChange = (val) => {
    if (DeliveryType[val] == '快递') {
        formData.value.delivery_time = ''
        formData.value.shop_delivery_time = ''
    } else {
        if (DeliveryType[val] == '仅自提') {
            formData.value.delivery_time = ''
        } else if (DeliveryType[val] == '仅配送') {
            formData.value.shop_delivery_time = ''
        }
    }
}

// 根据用户类型判断，蛋糕员工操作可选择当天，商户操作必须大于当天
const disabledStartDate = (date) => { // 返回开始不可用日期，开始日期要大于等于当天；如果有结束日期，开始日期不能大于结束日期
    const curr = new Date().getTime()
    const start = date.getTime()
    // const end = new Date(formData.value.end_date).getTime()

    if (UserType[userType] == '蛋叔员工') {
        return start < (curr - 1000 * 60 * 60 * 24)
    } else {
        return start < curr
    }

    // if (end) {
    //     return start > end || start < curr
    // } else {
    //     return start < curr
    // }
}
const disabledEndDate = (date) => { // 返回结束不可用日期，结束日期要大于等于开始日期
    const curr = new Date().getTime()
    const start = new Date(formData.value.start_date).getTime() - 1000*60*60*24 // 开始与结束可以是同一天
    const end = date.getTime()

    return end < start
    
    // if (start) {
    //     return end < start || end < curr
    // } else {
    //     return end < curr
    // }
}
// 输入配送时间段或自提时间段时，验证格式是否正确
const onInput = (fieldName, val) => {
    if (val) {
        // 将中文逗号替换为英文逗号，中文冒号替换为英文冒号
        const newVal = val.replace(/，/g, ',').replace(/：/g, ':')
        formData.value[fieldName] = newVal
        
        // 校验格式
        const regex = /^[0-9,:-]+$/;
        if (!regex.test(newVal)) {
            proxy.$message({ type: 'error', message: '输入格式错误，注意输入英文符号' })
            return
        }
        
        // 校验每个时间段的结束时间是否大于开始时间
        const timeRanges = newVal.split(',')
        for (const timeRange of timeRanges) {
            const [startTime, endTime] = timeRange.split('-')
            if (startTime && endTime) {
                // 将时间转换为分钟数进行比较
                const startMinutes = convertTimeToMinutes(startTime)
                const endMinutes = convertTimeToMinutes(endTime)
                if (startMinutes >= endMinutes) {
                    proxy.$message({ type: 'error', message: '时间段的结束时间必须大于开始时间' })
                    return
                }
            }
        }
    }
}

// 将时间字符串转换为分钟数
const convertTimeToMinutes = (timeStr) => {
    const [hours, minutes] = timeStr.split(':').map(Number)
    return hours * 60 + minutes
}

// 门店列表与变更监听
const shopList = ref<any>([]) // 门店列表
const isShopSelectedAll = ref(false)
const isShopSelectIndeterminate = ref(false)
const getShopList = async () => {
    const city_ids_params = formData.value.city_ids == 0 ? '' : formData.value.city_ids.join(',')
    const { code, data, msg } = await getShopListByBrandApi(formData.value.brand_id, city_ids_params) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

    
    
    // 为已选中的门店标识为已选中状态
    data.forEach(shop => {
        shop.selected = formData.value.shop_ids.includes(shop.id)
    })

    shopList.value = data
}
const onShopSelectAll = (val) => {
    isShopSelectedAll.value = val
    isShopSelectIndeterminate.value = false
    if (val) {
        formData.value.shop_ids = shopList.value.map(item => item.id)

        // 所有门店的 selected 全部标记为 true
        shopList.value.forEach(shop => {
            shop.selected = true
        })
    } else {
        formData.value.shop_ids = []
        
        // 所有门店的 selected 全部标记为 true
        shopList.value.forEach(shop => {
            shop.selected = false
        })
    }
}
const onShopChange = (val) => {
    isShopSelectedAll.value = false
    isShopSelectIndeterminate.value = false
    if (val.length === shopList.value.length) {
        isShopSelectedAll.value = true
    } else if (val.length > 0) {
        isShopSelectIndeterminate.value = true
    }
    if (formData.value.is_business_open == 0) {
        getShopList()
    }
    
    // 为已选中的门店标识为已选中状态
    shopList.value.forEach(shop => {
        shop.selected = val.includes(shop.id)
    })
}

// 按照原配送规则收取运费字段监听
const isSameShip = ref(true)
const onChangeFreeShip = (val) => {
    if (val) {
        formData.value.ship_amount = ''
    }
}

const submitForm = async() => {
    const sensitiveResult = await isSensitive(formData.value.description)
    if (sensitiveResult !== true) return proxy.$message({ type: 'error', message: `配规描述中包含敏感词：${sensitiveResult}` })

    // 非快递类判断每个城市下至少保留一个门店
    if (formData.value.delivery_type != 4 && formData.value.shop_ids.length) {
        for (const cityId of formData.value.city_ids) {
            const shopCount = shopList.value.filter(shop => shop.city_id == cityId).length
            const shopSelectedCount = shopList.value.filter(shop => shop.city_id == cityId && shop.selected).length
            if (shopCount && shopCount == shopSelectedCount) {
                const cityName = cityList.value.find(city => city.id == cityId)?.name
                proxy.$message({ type: 'error', message: `城市【${cityName}】下至少保留一个门店（整个城市不营业时，仅提交到城市维度即可）` })
                return
            }
        }
    }

    proxy.$refs['editForm'].validate((valid:boolean) => {
        if (valid) {
            saveSpecialRuleApi({
                ...formData.value,
                city_ids: formData.value.city_ids.join(','),
                second_brand_ids: formData.value.second_brand_ids.join(','),
                shop_ids: formData.value.shop_ids.join(','),
                product_ids: formData.value.product_ids.join(',')
            }).then((res:any) => {
                const { code, msg } = res
                if (code != 200) {return proxy.$message({ type: 'error', message: msg}) }
                proxy.$message({ type: 'success', message: '保存成功' })
                goBackList()
            })
        }
    })
}
// 表单验证规则
const checkTimes = (rule:any, val:any, callback:any) => { // 验证时间段格式
    const regex = /^[0-9,:-]+$/;

    if (val && !regex.test(val)) {
        callback(new Error('输入格式错误，注意输入英文符号'))
    } else {
        callback()
    }
}
const checkStartDate = (rule:any, val:any, callback:any) => { // 判断配规开始日期必须大于当前日期
    if (UserType[userType] == '蛋叔员工' && (new Date(val).getTime() < ( Date.now() - 1000 * 60 * 60 * 24))) {
        callback(new Error('配规开始日期须大于等于今天'))
    } else if (UserType[userType] == '合作商户' && new Date(val).getTime() < Date.now()) {
        callback(new Error('配规开始日期必须晚于今天'))
    } else if (formData.value.end_date && new Date(val).getTime() > new Date(formData.value.end_date).getTime()) {
        callback(new Error('配规开始日期必须晚于配规结束日期'))
    } else {
        callback()
    }
}
const checkEndDate = (rule:any, val:any, callback:any) => { // 判断配规结束日期必须大于当前日期
    if (formData.value.start_date && new Date(val).getTime() < new Date(formData.value.start_date).getTime()) {
        callback(new Error('配规结束日期必须等于或大于配规开始日期'))
    } else {
        callback()
    }
}
const rules = reactive({
    brand_id: [
        { required: true, message: '请选择品牌', trigger: 'change' }
    ],
    cat_id: [
        { required: true, message: '请选择品牌品类', trigger: 'change' }
    ],
    is_business_open: [
        { required: true, message: '请选择是否营业', trigger: 'change' }
    ],
    is_delivery_enabled: [
        { required: true, message: '请选择是否发货', trigger: 'change' }
    ],
    start_date: [
        { required: true, message: '请选择闭店开始日期', trigger: 'change' },
        { validator: checkStartDate, trigger: 'change' }
    ],
    end_date: [
        { required: true, message: '请选择闭店结束日期', trigger: 'change' },
        { validator: checkEndDate, trigger: 'change' }
    ],
    delivery_type: [
        { required: true, message: '请选择配送类型', trigger: 'change' },
    ],
    delivery_time: [
        { validator: checkTimes, trigger: 'blur' }
    ],
    shop_delivery_time: [
        { required: true, message: '请输入自提时间段', trigger: 'blur' },
        { validator: checkTimes, trigger: 'blur' }
    ],
    description: [
        { required: true, message: '请输入配规描述', trigger: 'blur' }
    ],
})

// 返回列表页时添加缓存参数
const goBackList = () => {
    const { cat_id, is_business_open } = formData.value
    sessionStorage.setItem('filterType', is_business_open ? cat_id : 99)
    router.go(-1)
}

// 审核通过
const onPass = () => {
    if (new Date(formData.value.start_date).getTime() < Date.now()) return proxy.$message({ type: 'error', message: '配规开始日期不能早于当前时间。请驳回，告知商户修改配规开始日期' })
    proxy.$confirm('确认要通过此条配规？', '提示', {
        type: 'warning'
    }).then(async () => {
        const { code, data, msg } = await checkSpecialRuleApi(id, 2) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '成功' })
        // 菜单提醒数字减一
        // store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule')
        goBackList()
    }).catch(() => {
        console.log('取消')
    })
}
// 审核驳回
const  reject_reason = ref('') // 驳回原因
const rejectDialog = ref(false)
const onReject = async () => {
    if (!reject_reason.value) return proxy.$message.error('请填写驳回原因')
    const { code, data, msg } = await checkSpecialRuleApi(id, 3, reject_reason.value) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    proxy.$message({ type: 'success', message: '成功' })
    rejectDialog.value = false
    reject_reason.value = ''
    // 菜单提醒数字减一
    // store.commit(UserMutationTypes.MINUS_MENU_WARNING_ITEM, 'cj_distribution_rule')
    goBackList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (formData.value.approval_status == 3)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          class: "mb20",
          type: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode("驳回原因：" + _toDisplayString(formData.value.reject_reason), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      class: "form",
      ref: "editForm",
      rules: rules,
      model: formData.value,
      disabled: _unref(t) == 2,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "品牌",
          prop: "brand_id",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select_v2, {
              modelValue: formData.value.brand_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.brand_id) = $event)),
              filterable: "",
              placeholder: "请选择品牌",
              onChange: onBrandChange,
              options: brandList.value,
              props: {
                        value: 'id',
                        label: 'name'
                    }
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "品类",
          prop: "cat_id",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formData.value.cat_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.cat_id) = $event)),
              disabled: "",
              placeholder: "请选择品类"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "蛋糕",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "零食",
                  value: 5
                }),
                _createVNode(_component_el_option, {
                  label: "鲜花",
                  value: 8
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_unref(DeliveryType)[brandCanDeliveryType.value] == '快递')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "是否发货",
              prop: "is_delivery_enabled",
              required: "",
              onChange: onCanDeliveryChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.is_delivery_enabled,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.is_delivery_enabled) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[33] || (_cache[33] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              label: "是否营业",
              prop: "is_business_open",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.is_business_open,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.is_business_open) = $event)),
                  onChange: onBusinessOpenChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("否")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })),
        (brandCanDeliveryType.value && brandCanDeliveryType.value != 4 && formData.value.is_business_open == 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "闭店起止日期",
                    prop: "start_date",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.start_date,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.start_date) = $event)),
                        "disabled-date": disabledStartDate,
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        placeholder: "闭店开始日期"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "0px",
                    prop: "end_date",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "ml10 mr10" }, "--", -1)),
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.end_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.end_date) = $event)),
                        "disabled-date": disabledEndDate,
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        placeholder: "闭店结束日期"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "城市" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.city_ids,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.city_ids) = $event)),
                    filterable: "",
                    multiple: "",
                    "collapse-tags": "",
                    "max-collapse-tags": 5,
                    clearable: "",
                    placeholder: "请选择城市",
                    onChange: onCityChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "门店" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.shop_ids,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.shop_ids) = $event)),
                    filterable: "",
                    multiple: "",
                    "collapse-tags": "",
                    "max-collapse-tags": 5,
                    clearable: "",
                    placeholder: "请选择门店",
                    onChange: onShopChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        class: "ml20",
                        modelValue: isShopSelectedAll.value,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShopSelectedAll).value = $event)),
                        indeterminate: isShopSelectIndeterminate.value,
                        label: "全选",
                        onChange: onShopSelectAll
                      }, null, 8, ["modelValue", "indeterminate"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "ml10 color-danger" }, "注：整个城市不营业时，仅提交到城市维度即可", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "配送描述",
                prop: formData.value.cat_id != 1 ? 'description' : '',
                required: formData.value.delivery_type == 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    placeholder: "例：1月1日-1月10日特殊期间，xxxxxx",
                    modelValue: formData.value.description,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.description) = $event)),
                    rows: 4,
                    "show-word-limit": "",
                    maxlength: "100",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "ml10 color-warning" }, "注：此描述将会展示给用户，请谨慎填写", -1))
                ]),
                _: 1
              }, 8, ["prop", "required"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "配规起止日期",
                    prop: "start_date",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.start_date,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.start_date) = $event)),
                        "disabled-date": disabledStartDate,
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        placeholder: "配规开始日期"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "0px",
                    prop: "end_date",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _cache[39] || (_cache[39] = _createElementVNode("span", { class: "ml10 mr10" }, "--", -1)),
                      _createVNode(_component_el_date_picker, {
                        modelValue: formData.value.end_date,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.end_date) = $event)),
                        "disabled-date": disabledEndDate,
                        type: "date",
                        "value-format": "YYYY-MM-DD",
                        placeholder: "配规结束日期"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "配送类型",
                prop: "delivery_type",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.delivery_type,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.delivery_type) = $event)),
                    placeholder: "请选择配送类型",
                    onChange: onDeliveryTypeChange
                  }, {
                    default: _withCtx(() => [
                      (brandCanDeliveryType.value != 4)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 0,
                            label: "仅自提",
                            value: 1
                          }))
                        : _createCommentVNode("", true),
                      (brandCanDeliveryType.value == 2 || brandCanDeliveryType.value == 3)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 1,
                            label: "仅配送",
                            value: 2
                          }))
                        : _createCommentVNode("", true),
                      (brandCanDeliveryType.value == 2 || brandCanDeliveryType.value == 3)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 2,
                            label: "配送+自提",
                            value: 3
                          }))
                        : _createCommentVNode("", true),
                      (brandCanDeliveryType.value == 4)
                        ? (_openBlock(), _createBlock(_component_el_option, {
                            key: 3,
                            label: "快递",
                            value: 4
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (formData.value.delivery_type == 2 || formData.value.delivery_type == 3)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "配送时间段",
                    prop: "delivery_time"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.delivery_time,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.delivery_time) = $event)),
                        modelModifiers: { trim: true },
                        type: "textarea",
                        rows: 4,
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (onInput('delivery_time', formData.value.delivery_time))),
                        placeholder: "例：9:00-12:00,11:00-13:00...",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _cache[40] || (_cache[40] = _createElementVNode("span", { class: "ml10 color-warning" }, "注：配送时间段，多个以英文逗号分隔", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (formData.value.delivery_type == 1 || formData.value.delivery_type == 3)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "自提时间段",
                    prop: "shop_delivery_time",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (onInput('shop_delivery_time', formData.value.shop_delivery_time))),
                        modelValue: formData.value.shop_delivery_time,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.shop_delivery_time) = $event)),
                        modelModifiers: { trim: true },
                        type: "textarea",
                        rows: 4,
                        placeholder: "例：9:00-12:00,11:00-13:00...",
                        clearable: ""
                      }, null, 8, ["modelValue"]),
                      _cache[41] || (_cache[41] = _createElementVNode("span", { class: "ml10 color-warning" }, "注：自提时间段，多个以英文逗号分隔", -1))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (formData.value.cat_id != 1)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    label: "二级品牌"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.second_brand_ids,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.second_brand_ids) = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        "max-collapse-tags": 5,
                        placeholder: "请选择二级品牌",
                        onChange: onSecondBrandChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondBrandList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(DeliveryType)[brandCanDeliveryType.value] == '快递')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    label: "商品"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.product_ids,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.product_ids) = $event)),
                        multiple: "",
                        "collapse-tags": "",
                        "max-collapse-tags": 5,
                        clearable: "",
                        placeholder: "请选择商品",
                        onChange: onProductChange
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_checkbox, {
                            class: "ml20",
                            modelValue: isProductSelectedAll.value,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isProductSelectedAll).value = $event)),
                            indeterminate: isProductSelectIndeterminate.value,
                            label: "全选",
                            onChange: onProductSelectAll
                          }, null, 8, ["modelValue", "indeterminate"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.title,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, { label: "城市" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.city_ids,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.city_ids) = $event)),
                    filterable: "",
                    multiple: "",
                    "collapse-tags": "",
                    "max-collapse-tags": 5,
                    clearable: "",
                    placeholder: "请选择城市",
                    onChange: onCityChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "配送描述",
                prop: _unref(DeliveryType)[brandCanDeliveryType.value] == '快递' ? 'description' : '',
                required: _unref(DeliveryType)[brandCanDeliveryType.value] == '快递'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    placeholder: "例：1月1日-1月10日特殊期间，xxxxxx",
                    modelValue: formData.value.description,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.description) = $event)),
                    rows: 4,
                    "show-word-limit": "",
                    maxlength: "100",
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "ml10 color-warning" }, "注：此描述将会展示给用户，请谨慎填写", -1))
                ]),
                _: 1
              }, 8, ["prop", "required"]),
              (formData.value.second_brand_ids.length == 0)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 4,
                    label: "运费"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        placeholder: "请输入运费",
                        disabled: isSameShip.value || isSupportShipAmount.value,
                        modelValue: formData.value.ship_amount,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.ship_amount) = $event)),
                        modelModifiers: { trim: true },
                        max: "50",
                        onInput: _cache[23] || (_cache[23] = ($event: any) => (formData.value.ship_amount>50 || formData.value.ship_amount<0 ?formData.value.ship_amount='':null))
                      }, {
                        append: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode("元")
                        ])),
                        _: 1
                      }, 8, ["disabled", "modelValue"]),
                      _createVNode(_component_el_checkbox, {
                        modelValue: isSameShip.value,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((isSameShip).value = $event)),
                        disabled: isSupportShipAmount.value,
                        title: getNotSupportShipAmountReason(),
                        class: "ml10",
                        onChange: onChangeFreeShip
                      }, {
                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                          _createTextVNode(" 按照原配送规则收取运费 ")
                        ])),
                        _: 1
                      }, 8, ["modelValue", "disabled", "title"]),
                      (_unref(UserType)[_unref(userType)] == '蛋叔员工' && formData.value.start_date == _unref(getCurrentDate)())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "注：工作人员选择开始日期为当天，即不可修改运费"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64)),
        (_unref(t) != 2 && _unref(source) == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, { key: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "info",
                  plain: "",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_unref(router).go(-1)))
                }, {
                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                    _createTextVNode("返回")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (submitForm()))
                }, {
                  default: _withCtx(() => _cache[46] || (_cache[46] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rules", "model", "disabled"]),
    (_unref(source) == 2 && formData.value.approval_status == 1)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          style: {"padding-left":"120px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onPass
            }, {
              default: _withCtx(() => _cache[47] || (_cache[47] = [
                _createTextVNode("通过")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (rejectDialog.value = true))
            }, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createTextVNode("驳回")
              ])),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "驳回",
      modelValue: rejectDialog.value,
      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((rejectDialog).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[29] || (_cache[29] = ($event: any) => (rejectDialog.value = false))
        }, {
          default: _withCtx(() => _cache[49] || (_cache[49] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[30] || (_cache[30] = ($event: any) => (onReject()))
        }, {
          default: _withCtx(() => _cache[50] || (_cache[50] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "驳回原因",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: reject_reason.value,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((reject_reason).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})